import React from 'react';
import { Phone, Mail, Instagram, MessageCircle, Youtube } from 'lucide-react';
import { contactInfo, socialLinks } from '../data/mock';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="top-bar-container">
        <div className="top-bar-left">
          <a href={`tel:${contactInfo.phone}`} className="top-bar-link">
            <Phone className="icon-small" />
            <span>{contactInfo.phone}</span>
          </a>
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=astroclick10@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="top-bar-link"
          >
            <Mail className="icon-small" />
            <span>{contactInfo.email}</span>
          </a>
        </div>
        <div className="top-bar-right">
          <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-icon">
            <Instagram className="icon-small" />
          </a>
          <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="social-icon">
            <MessageCircle className="icon-small" />
          </a>
          <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" className="social-icon">
            <Youtube className="icon-small" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;